import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="content has-text-centered">
      <p>
        <strong>My Travel App</strong> by ATOM
      </p>
    </div>
  </footer>
);

export default Footer;
